import {createSelector} from '@reduxjs/toolkit'

import {RootState} from '../interfaces'

export const aitemsSelector = (state: RootState) => state.aitems

export const adStatusSelector = (state: RootState) => state.aitems.adStatus

export const nvMidsSelector = createSelector(
    (state: RootState) => state.aitems.products,
    (products): Maybe<string> => {
        const nvMids = products
            .filter((ecNvMid) => !!ecNvMid)
            .splice(0, 6)
            .map(({ecNvMid}) => ecNvMid)
            .join(',')

        return nvMids || null
    },
)
